import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">
         <span className="section-number"></span>Professional Overview</h2>
        
        <div className="about-content">
          <div className="about-text">
            <p>
              DevOps & Cloud Engineer with 9+ years of experience spanning IT operations, 
              infrastructure, and cloud-native engineering. Skilled in building scalable 
              platforms on AWS, Azure, and GCP, automating deployments with CI/CD pipelines, 
              and containerizing applications with Docker and Kubernetes (EKS & GKE).
            </p>
            <p>
              Proven track record in implementing GitOps workflows, infrastructure as code 
              (Terraform, Helm), and observability stacks (Prometheus, Grafana, Loki, Tempo, 
              CloudWatch). Experienced in deploying and operationalizing AI/LLM models in 
              GCP (Vertex AI) and Azure OpenAI, integrating ML workloads into production systems.
            </p>
            <p>
              Experience leading IT and DevOps initiatives across distributed environments,
              delivering secure, reliable, and automated platforms that improve system
              resilience and support business growth within enterprise and mission-critical
              technology domains.
            </p>
            
            <div className="about-highlights">
              <div className="highlight-item">
                <svg viewBox="0 0 24 24" fill="none" className="highlight-icon">
                  <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
                <div>
                  <h4>9+ Years Experience</h4>
                  <p>IT operations to cloud-native engineering</p>
                </div>
              </div>
              
              <div className="highlight-item">
                <svg viewBox="0 0 24 24" fill="none" className="highlight-icon">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <div>
                  <h4>Multi-Cloud Expert</h4>
                  <p>AWS, Azure, and GCP platforms</p>
                </div>
              </div>
              
              <div className="highlight-item">
                <svg viewBox="0 0 24 24" fill="none" className="highlight-icon">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
                <div>
                  <h4>AI/LLM Integration</h4>
                  <p>Vertex AI & Azure OpenAI deployments</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="about-visual">
            <svg viewBox="0 0 400 400" className="about-illustration">
              <defs>
                <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor: '#64FFDA', stopOpacity: 1}} />
                  <stop offset="100%" style={{stopColor: '#667EEA', stopOpacity: 1}} />
                </linearGradient>
                <filter id="glow">
                  <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                  <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>
              
              {/* Pipeline visualization */}
              <g className="pipeline">
                {/* Stages */}
                <circle cx="80" cy="200" r="30" fill="var(--secondary-bg)" stroke="url(#grad3)" strokeWidth="3" filter="url(#glow)"/>
                <text x="80" y="205" textAnchor="middle" fill="var(--accent)" fontSize="12" fontWeight="600">CODE</text>
                
                <line x1="110" y1="200" x2="150" y2="200" stroke="url(#grad3)" strokeWidth="2" strokeDasharray="5,5">
                  <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
                </line>
                
                <circle cx="180" cy="200" r="30" fill="var(--secondary-bg)" stroke="url(#grad3)" strokeWidth="3" filter="url(#glow)"/>
                <text x="180" y="205" textAnchor="middle" fill="var(--accent)" fontSize="12" fontWeight="600">BUILD</text>
                
                <line x1="210" y1="200" x2="250" y2="200" stroke="url(#grad3)" strokeWidth="2" strokeDasharray="5,5">
                  <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
                </line>
                
                <circle cx="280" cy="200" r="30" fill="var(--secondary-bg)" stroke="url(#grad3)" strokeWidth="3" filter="url(#glow)"/>
                <text x="280" y="205" textAnchor="middle" fill="var(--accent)" fontSize="12" fontWeight="600">TEST</text>
                
                <line x1="280" y1="230" x2="280" y2="270" stroke="url(#grad3)" strokeWidth="2" strokeDasharray="5,5">
                  <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite"/>
                </line>
                
                <circle cx="280" cy="300" r="30" fill="var(--secondary-bg)" stroke="url(#grad3)" strokeWidth="3" filter="url(#glow)"/>
                <text x="280" y="305" textAnchor="middle" fill="var(--accent)" fontSize="11" fontWeight="600">DEPLOY</text>
              </g>
              
              {/* Decorative elements */}
              <circle cx="350" cy="100" r="5" fill="var(--accent)" opacity="0.6">
                <animate attributeName="r" values="5;8;5" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="50" cy="350" r="5" fill="var(--accent)" opacity="0.6">
                <animate attributeName="r" values="5;8;5" dur="2.5s" repeatCount="indefinite"/>
              </circle>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

